import { render, staticRenderFns } from "./UploadImgOne.vue?vue&type=template&id=2d595b57&"
import script from "./UploadImgOne.vue?vue&type=script&lang=js&"
export * from "./UploadImgOne.vue?vue&type=script&lang=js&"
import style0 from "./UploadImgOne.vue?vue&type=style&index=0&id=2d595b57&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports